import { Clients } from '../pages/Clients';
import { Contacts } from '../pages/Contacts';
import { Emails } from '../pages/Emails';
import { Login } from '../pages/Login';
import { Main } from '../pages/Main';
import { Registration } from '../pages/Registration';
import { Reminders } from '../pages/Reminders';
import { Settings } from '../pages/Settings';
import { ParserView } from '../pages/ParserView';
import { ImportHistory } from '../pages/ImportHistory';
import { AutoImportRules } from '../pages/AutoImportRules';

export const routesNonAuthorised = [
  {
    id: 1,
    path: '/',
    isAuthorised: false,
    element: <Login />,
  },
  {
    id: 2,
    path: '/login',
    isAuthorised: false,
    element: <Login />,
  },
  {
    id: 3,
    path: '/registration',
    isAuthorised: false,
    element: <Registration />,
  },
];

export const routesAuthorised = [
  {
    id: 1,
    path: '/',
    isAuthorised: true,
    element: <Main />,
  },
  {
    id: 2,
    path: '/settings',
    isAuthorised: true,
    element: <Settings />,
  },
  {
    id: 3,
    path: '/clients',
    isAuthorised: true,
    element: <Clients />,
  },
  {
    id: 9,
    path: '/contacts',
    isAuthorised: true,
    element: <Contacts />,
  },
  {
    id: 4,
    path: '/reminders',
    isAuthorised: true,
    element: <Reminders />,
  },
  {
    id: 5,
    path: '/emails',
    isAuthorised: true,
    element: <Emails />,
  },
  {
    id: 6,
    path: '/settings/parser/view',
    isAuthorised: true,
    element: <ParserView />,
  },
  {
    id: 7,
    path: '/settings/parser/imports',
    adminOnly: true,
    isAuthorised: true,
    element: <ImportHistory />,
  },
  {
    id: 8,
    path: '/settings/parser/auto-import',
    adminOnly: true,
    isAuthorised: true,
    element: <AutoImportRules />,
  },
];
